import React from "react";

const Kotlin_While_Loop = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin While Loop</h1>
      <p>Content for Kotlin While Loop goes here.</p>
    </div>
  );
};

export default Kotlin_While_Loop;
